import type { LocationDropdownItem } from './updateOrder';

export const COUNTRIES: LocationDropdownItem[] = [
  {
    en: 'United States',
    twoLetterCode: 'us',
    dial_code: '+1',
    fr: 'États-Unis',
    es: 'Estados Unidos',
    de: 'USA',
    nl: 'Verenigde Staten',
    zh: '美国',
  },
  {
    en: 'Canada',
    twoLetterCode: 'ca',
    dial_code: '+1',
    fr: 'Canada',
    es: 'Canadá',
    de: 'Kanada',
    nl: 'Canada',
    zh: '加拿大',
  },
  {
    en: 'United Kingdom',
    twoLetterCode: 'gb',
    dial_code: '+44',
    fr: 'Royaume-Uni',
    es: 'Reino Unido',
    de: 'Vereinigtes Königreich',
    nl: 'Verenigd Koninkrijk',
    zh: '英国',
  },
  {
    en: 'Afghanistan',
    twoLetterCode: 'af',
    dial_code: '+93',
    fr: 'Afghanistan',
    es: 'Afganistán',
    de: 'Afghanistan',
    nl: 'Afghanistan',
    zh: '阿富汗',
  },
  {
    en: 'Albania',
    twoLetterCode: 'al',
    dial_code: '+355',
    fr: 'Albanie',
    es: 'Albania',
    de: 'Albanien',
    nl: 'Albanië',
    zh: '阿尔巴尼亚',
  },
  {
    en: 'Algeria',
    twoLetterCode: 'dz',
    dial_code: '+213',
    fr: 'Algérie',
    es: 'Argelia',
    de: 'Algerien',
    nl: 'Algerije',
    zh: '阿尔及利亚',
  },
  {
    en: 'American Samoa',
    twoLetterCode: 'as',
    dial_code: '+1684',
    fr: 'Samoa américaines',
    es: 'Samoa Americana',
    de: 'Amerikanisch-Samoa',
    nl: 'Amerikaans Samoa',
    zh: '美属萨摩亚',
  },
  {
    en: 'Andorra',
    twoLetterCode: 'ad',
    dial_code: '+376',
    fr: 'Andorre',
    es: 'Andorra',
    de: 'Andorra',
    nl: 'Andorra',
    zh: '安道尔',
  },
  {
    en: 'Angola',
    twoLetterCode: 'ao',
    dial_code: '+244',
    fr: 'Angola',
    es: 'Angola',
    de: 'Angola',
    nl: 'Angola',
    zh: '安哥拉',
  },
  {
    en: 'Anguilla',
    twoLetterCode: 'ai',
    dial_code: '+1264',
    fr: 'Anguilla',
    es: 'Anguilla',
    de: 'Anguilla',
    nl: 'Anguilla',
    zh: '安圭拉',
  },
  {
    en: 'Antarctica',
    twoLetterCode: 'aq',
    fr: 'Antarctique',
    es: 'Antártida',
    de: 'Antarktis',
    nl: 'Antarctica',
    zh: '南极洲',
  },
  {
    en: 'Antigua and Barbuda',
    twoLetterCode: 'ag',
    fr: 'Antigua-et-Barbuda',
    es: 'Antigua y Barbuda',
    de: 'Antigua und Barbuda',
    nl: 'Antigua en Barbuda',
    zh: '安提瓜和巴布达',
  },
  {
    en: 'Argentina',
    twoLetterCode: 'ar',
    dial_code: '+54',
    fr: 'Argentine',
    es: 'Argentina',
    de: 'Argentinien',
    nl: 'Argentinië',
    zh: '阿根廷',
  },
  {
    en: 'Armenia',
    twoLetterCode: 'am',
    dial_code: '+374',
    fr: 'Arménie',
    es: 'Armenia',
    de: 'Armenien',
    nl: 'Armenië',
    zh: '亚美尼亚',
  },
  {
    en: 'Aruba',
    twoLetterCode: 'aw',
    dial_code: '+297',
    fr: 'Aruba',
    es: 'Aruba',
    de: 'Aruba',
    nl: 'Aruba',
    zh: '阿鲁巴',
  },
  {
    en: 'Australia',
    twoLetterCode: 'au',
    dial_code: '+61',
    fr: 'Australie',
    es: 'Australia',
    de: 'Australien',
    nl: 'Australië',
    zh: '澳大利亚',
  },
  {
    en: 'Austria',
    twoLetterCode: 'at',
    dial_code: '+43',
    fr: 'Autriche',
    es: 'Austria',
    de: 'Österreich',
    nl: 'Oostenrijk',
    zh: '奥地利',
  },
  {
    en: 'Azerbaijan',
    twoLetterCode: 'az',
    dial_code: '+994',
    fr: 'Azerbaïdjan',
    es: 'Azerbaiyán',
    de: 'Aserbaidschan',
    nl: 'Azerbeidzjan',
    zh: '阿塞拜疆',
  },
  {
    en: 'Bahamas',
    twoLetterCode: 'bs',
    dial_code: '+1242',
    fr: 'Bahamas',
    es: 'Bahamas',
    de: 'Bahamas',
    nl: 'Bahamas',
    zh: '巴哈马',
  },
  {
    en: 'Bahrain',
    twoLetterCode: 'bh',
    dial_code: '+973',
    fr: 'Bahreïn',
    es: 'Bahréin',
    de: 'Bahrain',
    nl: 'Bahrein',
    zh: '巴林',
  },
  {
    en: 'Bangladesh',
    twoLetterCode: 'bd',
    dial_code: '+880',
    fr: 'Bangladesh',
    es: 'Bangladés',
    de: 'Bangladesch',
    nl: 'Bangladesh',
    zh: '孟加拉',
  },
  {
    en: 'Barbados',
    twoLetterCode: 'bb',
    dial_code: '+1246',
    fr: 'Barbade',
    es: 'Barbados',
    de: 'Barbados',
    nl: 'Barbados',
    zh: '巴巴多斯',
  },
  {
    en: 'Belarus',
    twoLetterCode: 'by',
    dial_code: '+375',
    fr: 'Biélorussie',
    es: 'Bielorrusia',
    de: 'Weißrussland',
    nl: 'Wit-Rusland',
    zh: '白俄罗斯',
  },
  {
    en: 'Belgium',
    twoLetterCode: 'be',
    dial_code: '+32',
    fr: 'Belgique',
    es: 'Bélgica',
    de: 'Belgien',
    nl: 'België',
    zh: '比利时',
  },
  {
    en: 'Belize',
    twoLetterCode: 'bz',
    dial_code: '+501',
    fr: 'Bélize',
    es: 'Belice',
    de: 'Belize',
    nl: 'Belize',
    zh: '伯利兹',
  },
  {
    en: 'Benin',
    twoLetterCode: 'bj',
    dial_code: '+229',
    fr: 'Bénin',
    es: 'Benín',
    de: 'Benin',
    nl: 'Benin',
    zh: '贝宁',
  },
  {
    en: 'Bermuda',
    twoLetterCode: 'bm',
    dial_code: '+1441',
    fr: 'Bermudes',
    es: 'Bermudas',
    de: 'Bermuda',
    nl: 'Bermuda',
    zh: '百慕大',
  },
  {
    en: 'Bhutan',
    twoLetterCode: 'bt',
    dial_code: '+975',
    fr: 'Bhoutan',
    es: 'Bután',
    de: 'Bhutan',
    nl: 'Bhutan',
    zh: '不丹',
  },
  {
    en: 'Bolivia, Plurinational State of',
    twoLetterCode: 'bo',
    dial_code: '+591',
    fr: 'Bolivie',
    es: 'Bolivia',
    de: 'Bolivien',
    nl: 'Bolivia',
    zh: '玻利维亚',
  },
  {
    en: 'Bosnia and Herzegovina',
    twoLetterCode: 'ba',
    dial_code: '+387',
    fr: 'Bosnie-Herzégovine',
    es: 'Bosnia y Herzegovina',
    de: 'Bosnien und Herzegowina',
    nl: 'Bosnië en Herzegovina',
    zh: '波斯尼亚和黑塞哥维那',
  },
  {
    en: 'Botswana',
    twoLetterCode: 'bw',
    dial_code: '+267',
    fr: 'Botswana',
    es: 'Botsuana',
    de: 'Botswana',
    nl: 'Botswana',
    zh: '博茨瓦纳',
  },
  {
    en: 'Brazil',
    twoLetterCode: 'br',
    dial_code: '+55',
    fr: 'Brésil',
    es: 'Brasil',
    de: 'Brasilien',
    nl: 'Brazilië',
    zh: '巴西',
  },
  {
    en: 'British Indian Ocean Territory',
    twoLetterCode: 'io',
    dial_code: '+246',
    fr: 'Territoire britannique de l’océan Indien',
    es: 'Territorio Británico del Océano Índico',
    de: 'Britisches Territorium im Indischen Ozean',
    nl: 'Brits Indische Oceaanterritorium',
    zh: '英属印度洋领地',
  },
  {
    en: 'Brunei Darussalam',
    twoLetterCode: 'bn',
    dial_code: '+673',
    fr: 'Brunei Darussalam',
    es: 'Brunei Darussalam',
    de: 'Brunei Darussalam',
    nl: 'Brunei Darussalam',
    zh: '文莱达鲁萨兰国',
  },
  {
    en: 'Bulgaria',
    twoLetterCode: 'bg',
    dial_code: '+359',
    fr: 'Bulgarie',
    es: 'Bulgaria',
    de: 'Bulgarien',
    nl: 'Bulgarije',
    zh: '保加利亚',
  },
  {
    en: 'Burkina Faso',
    twoLetterCode: 'bf',
    dial_code: '+226',
    fr: 'Burkina Faso',
    es: 'Burkina Faso',
    de: 'Burkina Faso',
    nl: 'Burkina Faso',
    zh: '布基纳法索',
  },
  {
    en: 'Burundi',
    twoLetterCode: 'bi',
    dial_code: '+257',
    fr: 'Burundi',
    es: 'Burundi',
    de: 'Burundi',
    nl: 'Burundi',
    zh: '布隆迪',
  },
  {
    en: 'Cambodia',
    twoLetterCode: 'kh',
    dial_code: '+855',
    fr: 'Cambodge',
    es: 'Camboya',
    de: 'Kambodscha',
    nl: 'Cambodja',
    zh: '柬埔寨',
  },
  {
    en: 'Cameroon',
    twoLetterCode: 'cm',
    dial_code: '+237',
    fr: 'Cameroun',
    es: 'Camerún',
    de: 'Kamerun',
    nl: 'Kameroen',
    zh: '喀麦隆',
  },
  {
    en: 'Cape Verde',
    twoLetterCode: 'cv',
    dial_code: '+238',
    fr: 'Cap Vert',
    es: 'Cabo Verde',
    de: 'Kap Verde',
    nl: 'Kaapverdië',
    zh: '佛得角',
  },
  {
    en: 'Cayman Islands',
    twoLetterCode: 'ky',
    dial_code: '+1345',
    fr: 'Îles Caïman',
    es: 'Islas Caimán',
    de: 'Kaimaninseln',
    nl: 'Kaaimaneilanden',
    zh: '开曼群岛',
  },
  {
    en: 'Central African Republic',
    twoLetterCode: 'cf',
    dial_code: '+236',
    fr: 'République centrafricaine',
    es: 'República Centroafricana',
    de: 'Zentralafrikanische Republik',
    nl: 'Centraal Afrikaanse Republiek',
    zh: '中非共和国',
  },
  {
    en: 'Chad',
    twoLetterCode: 'td',
    dial_code: '+235',
    fr: 'Tchad',
    es: 'Chad',
    de: 'Tschad',
    nl: 'Tsjaad',
    zh: '乍得',
  },
  {
    en: 'Chile',
    twoLetterCode: 'cl',
    dial_code: '+56',
    fr: 'Chili',
    es: 'Chile',
    de: 'Chile',
    nl: 'Chili',
    zh: '智利',
  },
  {
    en: 'China',
    twoLetterCode: 'cn',
    dial_code: '+86',
    fr: 'Chine',
    es: 'China',
    de: 'China',
    nl: 'China',
    zh: '中国',
  },
  {
    en: 'Christmas Islands',
    valueOverride: 'Christmas Island',
    twoLetterCode: 'cx',
    dial_code: '+61',
    fr: 'Île Christmas',
    es: 'Isla de Navidad',
    de: 'Weihnachtsinsel',
    nl: 'Kersteiland',
    zh: '圣诞岛',
  },
  {
    en: 'Cocos (Keeling) Islands',
    twoLetterCode: 'cc',
    dial_code: '+61',
    fr: 'Îles Cocos',
    es: 'Islas Cocos',
    de: 'Kokosinsel (Keeling)',
    nl: 'Cocoseilanden',
    zh: '科科斯群岛',
  },
  {
    en: 'Colombia',
    twoLetterCode: 'co',
    dial_code: '+57',
    fr: 'Colombie',
    es: 'Colombia',
    de: 'Kolumbien',
    nl: 'Colombia',
    zh: '哥伦比亚',
  },
  {
    en: 'Comoros',
    twoLetterCode: 'km',
    dial_code: '+269',
    fr: 'Comores',
    es: 'Comoras',
    de: 'Komoren',
    nl: 'Comoren',
    zh: '科摩罗',
  },
  {
    en: 'Congo, the Democratic Republic of the',
    twoLetterCode: 'cd',
    dial_code: '+243',
    fr: 'Congo, République démocratique du (RDC)',
    es: 'Congo, República Democrática del',
    de: 'Kongo, Demokratische Republik',
    nl: 'Democratische Republiek Congo',
    zh: '刚果民主共和国',
  },
  {
    en: 'Congo, Republic of the',
    valueOverride: 'Congo',
    twoLetterCode: 'cg',
    dial_code: '+242',
    fr: 'Congo, République du',
    es: 'Congo, República del',
    de: 'Kongo, Republik',
    nl: 'Republiek Congo',
    zh: '刚果共和国',
  },
  {
    en: 'Cook Islands',
    twoLetterCode: 'ck',
    dial_code: '+682',
    fr: 'Îles Cook',
    es: 'Islas Cook',
    de: 'Cookinseln',
    nl: 'Cookeilanden',
    zh: '库克群岛',
  },
  {
    en: 'Costa Rica',
    twoLetterCode: 'cr',
    dial_code: '+506',
    fr: 'Costa Rica',
    es: 'Costa Rica',
    de: 'Costa Rica',
    nl: 'Costa Rica',
    zh: '哥斯达黎加',
  },
  {
    en: 'Croatia',
    twoLetterCode: 'hr',
    dial_code: '+385',
    fr: 'Croatie',
    es: 'Croacia',
    de: 'Kroatien',
    nl: 'Kroatië',
    zh: '克罗地亚',
  },
  {
    en: 'Cuba',
    twoLetterCode: 'cu',
    dial_code: '+53',
    fr: 'Cuba',
    es: 'Cuba',
    de: 'Kuba',
    nl: 'Cuba',
    zh: '古巴',
  },
  {
    en: 'Curaçao',
    twoLetterCode: 'cw',
    dial_code: '+599',
    fr: 'Curaçao',
    es: 'Curazao',
    de: 'Curaçao',
    nl: 'Curaçao',
    zh: '库拉索',
  },
  {
    en: 'Cyprus',
    twoLetterCode: 'cy',
    dial_code: '+357',
    fr: 'Chypre',
    es: 'Chipre',
    de: 'Zypern',
    nl: 'Cyprus',
    zh: '塞浦路斯',
  },
  {
    en: 'Czech Republic',
    twoLetterCode: 'cz',
    dial_code: '+420',
    fr: 'République tchèque',
    es: 'República Checa',
    de: 'Tschechische Republik',
    nl: 'Tsjechische Republiek',
    zh: '捷克',
  },
  {
    en: "Côte d'Ivoire",
    valueOverride: "Cote d'Ivoire",
    twoLetterCode: 'ci',
    dial_code: '+225',
    fr: "Côte d'Ivoire",
    es: 'Costa de Marfil',
    de: 'Elfenbeinküste',
    nl: 'Ivoorkust',
    zh: '科特迪瓦',
  },
  {
    en: 'Denmark',
    twoLetterCode: 'dk',
    dial_code: '+45',
    fr: 'Danemark',
    es: 'Dinamarca',
    de: 'Dänemark',
    nl: 'Denemarken',
    zh: '丹麦',
  },
  {
    en: 'Djibouti',
    twoLetterCode: 'dj',
    dial_code: '+253',
    fr: 'Djibouti',
    es: 'Yibuti',
    de: 'Dschibuti',
    nl: 'Djibouti',
    zh: '吉布提',
  },
  {
    en: 'Dominica',
    twoLetterCode: 'dm',
    dial_code: '+1767',
    fr: 'Dominique',
    es: 'Dominica',
    de: 'Dominica',
    nl: 'Dominica',
    zh: '多米尼加',
  },
  {
    en: 'Dominican Republic',
    twoLetterCode: 'do',
    dial_code: '+1809',
    fr: 'République dominicaine',
    es: 'República Dominicana',
    de: 'Dominikanische Republik',
    nl: 'Dominicaanse Republiek',
    zh: '多米尼加共和国',
  },
  {
    en: 'Ecuador',
    twoLetterCode: 'ec',
    dial_code: '+593',
    fr: 'Équateur',
    es: 'Ecuador',
    de: 'Ecuador',
    nl: 'Ecuador',
    zh: '厄瓜多尔',
  },
  {
    en: 'Egypt',
    twoLetterCode: 'eg',
    dial_code: '+20',
    fr: 'Égypte',
    es: 'Egipto',
    de: 'Ägypten',
    nl: 'Egypte',
    zh: '埃及',
  },
  {
    en: 'El Salvador',
    twoLetterCode: 'sv',
    dial_code: '+503',
    fr: 'El Salvador',
    es: 'El Salvador',
    de: 'El Salvador',
    nl: 'El Salvador',
    zh: '萨尔瓦多',
  },
  {
    en: 'Equatorial Guinea',
    twoLetterCode: 'gq',
    dial_code: '+240',
    fr: 'Guinée équatoriale',
    es: 'Guinea Ecuatorial',
    de: 'Äquatorialguinea',
    nl: 'Equatoriaal-Guinea',
    zh: '赤道几内亚',
  },
  {
    en: 'Eritrea',
    twoLetterCode: 'er',
    dial_code: '+291',
    fr: 'Érythrée',
    es: 'Eritrea',
    de: 'Eritrea',
    nl: 'Eritrea',
    zh: '厄立特里亚',
  },
  {
    en: 'Estonia',
    twoLetterCode: 'ee',
    dial_code: '+372',
    fr: 'Estonie',
    es: 'Estonia',
    de: 'Estland',
    nl: 'Estland',
    zh: '爱沙尼亚',
  },
  {
    en: 'Eswatini (Swaziland)',
    valueOverride: 'Swaziland',
    twoLetterCode: 'sz',
    dial_code: '+268',
    fr: 'Swaziland',
    es: 'Eswatini (Suazilandia)',
    de: 'Eswatini (Swasiland)',
    nl: 'Eswatini (Swaziland)',
    zh: '斯瓦蒂尼（斯威士兰）',
  },
  {
    en: 'Ethiopia',
    twoLetterCode: 'et',
    dial_code: '+251',
    fr: 'Éthiopie',
    es: 'Etiopía',
    de: 'Äthiopien',
    nl: 'Ethiopië',
    zh: '埃塞俄比亚',
  },
  {
    en: 'Falkland Islands',
    valueOverride: 'Falkland Islands (Malvinas)',
    twoLetterCode: 'fk',
    dial_code: '+500',
    fr: 'Îles Malouines',
    es: 'Islas Malvinas',
    de: 'Falklandinseln',
    nl: 'Falklandeilanden',
    zh: '福克兰群岛',
  },
  {
    en: 'Faroe Islands',
    twoLetterCode: 'fo',
    dial_code: '+298',
    fr: 'Îles Féroé',
    es: 'Islas Feroe',
    de: 'Färöer-Inseln',
    nl: 'Faeröer',
    zh: '法罗群岛',
  },
  {
    en: 'Fiji',
    twoLetterCode: 'fj',
    dial_code: '+679',
    fr: 'Fiji',
    es: 'Fiyi',
    de: 'Fidschi-Inseln',
    nl: 'Fiji',
    zh: '斐济',
  },
  {
    en: 'Finland',
    twoLetterCode: 'fi',
    dial_code: '+358',
    fr: 'Finlande',
    es: 'Finlandia',
    de: 'Finnland',
    nl: 'Finland',
    zh: '芬兰',
  },
  {
    en: 'France',
    twoLetterCode: 'fr',
    dial_code: '+33',
    fr: 'France',
    es: 'Francia',
    de: 'Frankreich',
    nl: 'Frankrijk',
    zh: '法国',
  },
  {
    en: 'French Guiana',
    twoLetterCode: 'gf',
    dial_code: '+594',
    fr: 'Guyane française',
    es: 'Guayana Francesa',
    de: 'Französisch-Guayana',
    nl: 'Frans-Guyana',
    zh: '法属圭亚那',
  },
  {
    en: 'French Polynesia',
    twoLetterCode: 'pf',
    dial_code: '+689',
    fr: 'Polynésie française',
    es: 'Polinesia Francesa',
    de: 'Französisch-Polynesien',
    nl: 'Frans-Polynesië',
    zh: '法属波利尼西亚',
  },
  {
    en: 'French Southern Territories',
    twoLetterCode: 'tf',
    dial_code: '+262',
    fr: 'Terres australes et antarctiques françaises',
    es: 'Territorios Australes Franceses',
    de: 'Französische Süd- und Antarktisgebiete',
    nl: 'Franse Zuidelijke Gebieden',
    zh: '法国南部领地',
  },
  {
    en: 'Gabon',
    twoLetterCode: 'ga',
    dial_code: '+241',
    fr: 'Gabon',
    es: 'Gabón',
    de: 'Gabun',
    nl: 'Gabon',
    zh: '加蓬',
  },
  {
    en: 'Gambia',
    twoLetterCode: 'gm',
    dial_code: '+220',
    fr: 'Gambie',
    es: 'Gambia',
    de: 'Gambia',
    nl: 'Gambia',
    zh: '冈比亚',
  },
  {
    en: 'Georgia',
    twoLetterCode: 'ge',
    dial_code: '+995',
    fr: 'Géorgie',
    es: 'Georgia',
    de: 'Georgien',
    nl: 'Georgië',
    zh: '格鲁吉亚',
  },
  {
    en: 'Germany',
    twoLetterCode: 'de',
    dial_code: '+49',
    fr: 'Allemagne',
    es: 'Alemania',
    de: 'Deutschland',
    nl: 'Duitsland',
    zh: '德国',
  },
  {
    en: 'Ghana',
    twoLetterCode: 'gh',
    dial_code: '+233',
    fr: 'Ghana',
    es: 'Ghana',
    de: 'Ghana',
    nl: 'Ghana',
    zh: '加纳',
  },
  {
    en: 'Gibraltar',
    twoLetterCode: 'gi',
    dial_code: '+350',
    fr: 'Gibraltar',
    es: 'Gibraltar',
    de: 'Gibraltar',
    nl: 'Gibraltar',
    zh: '直布罗陀',
  },
  {
    en: 'Greece',
    twoLetterCode: 'gr',
    dial_code: '+30',
    fr: 'Grèce',
    es: 'Grecia',
    de: 'Griechenland',
    nl: 'Griekenland',
    zh: '希腊',
  },
  {
    en: 'Greenland',
    twoLetterCode: 'gl',
    dial_code: '+299',
    fr: 'Groenland',
    es: 'Groenlandia',
    de: 'Grönland',
    nl: 'Groenland',
    zh: '格陵兰',
  },
  {
    en: 'Grenada',
    twoLetterCode: 'gd',
    dial_code: '+1473',
    fr: 'Grenade',
    es: 'Grenada',
    de: 'Grenada',
    nl: 'Grenada',
    zh: '格林纳达',
  },
  {
    en: 'Guadeloupe',
    twoLetterCode: 'gp',
    dial_code: '+590',
    fr: 'Guadeloupe',
    es: 'Guadalupe',
    de: 'Guadeloupe',
    nl: 'Guadeloupe',
    zh: '瓜德罗普岛',
  },
  {
    en: 'Guam',
    twoLetterCode: 'gu',
    dial_code: '+1671',
    fr: 'Guam',
    es: 'Guam',
    de: 'Guam',
    nl: 'Guam',
    zh: '关岛',
  },
  {
    en: 'Guatemala',
    twoLetterCode: 'gt',
    dial_code: '+502',
    fr: 'Guatemala',
    es: 'Guatemala',
    de: 'Guatemala',
    nl: 'Guatemala',
    zh: '危地马拉',
  },
  {
    en: 'Guernsey',
    twoLetterCode: 'gg',
    dial_code: '+44',
    fr: 'Guernsey',
    es: 'Guernsey',
    de: 'Guernsey',
    nl: 'Guernsey',
    zh: '根西岛',
  },
  {
    en: 'Guinea',
    twoLetterCode: 'gn',
    dial_code: '+224',
    fr: 'Guinée',
    es: 'Guinea',
    de: 'Guinea',
    nl: 'Guinea',
    zh: '几内亚',
  },
  {
    en: 'Guinea-Bissau',
    twoLetterCode: 'gw',
    dial_code: '+245',
    fr: 'Guinée-Bissau',
    es: 'Guinea-Bissau',
    de: 'Guinea-Bissau',
    nl: 'Guinea-Bissau',
    zh: '几内亚比绍',
  },
  {
    en: 'Guyana',
    twoLetterCode: 'gy',
    dial_code: '+592',
    fr: 'Guyana',
    es: 'Guyana',
    de: 'Guyana',
    nl: 'Guyana',
    zh: '圭亚那',
  },
  {
    en: 'Haiti',
    twoLetterCode: 'ht',
    dial_code: '+509',
    fr: 'Haïti',
    es: 'Haití',
    de: 'Haiti',
    nl: 'Haïti',
    zh: '海地',
  },
  {
    en: 'Holy See',
    valueOverride: 'Holy See (Vatican City State)',
    twoLetterCode: 'va',
    dial_code: '+39',
    fr: 'Saint-Siège',
    es: 'Santa Sede',
    de: 'Vatikanstadt',
    nl: 'Heilige Stoel',
    zh: '圣座',
  },
  {
    en: 'Honduras',
    twoLetterCode: 'hn',
    dial_code: '+504',
    fr: 'Honduras',
    es: 'Honduras',
    de: 'Honduras',
    nl: 'Honduras',
    zh: '洪都拉斯',
  },
  {
    en: 'Hong Kong',
    twoLetterCode: 'hk',
    dial_code: '+852',
    fr: 'Hong Kong',
    es: 'Hong Kong',
    de: 'Hongkong',
    nl: 'Hongkong',
    zh: '中国香港',
  },
  {
    en: 'Hungary',
    twoLetterCode: 'hu',
    dial_code: '+36',
    fr: 'Hongrie',
    es: 'Hungría',
    de: 'Ungarn',
    nl: 'Hongarije',
    zh: '匈牙利',
  },
  {
    en: 'Iceland',
    twoLetterCode: 'is',
    dial_code: '+354',
    fr: 'Islande',
    es: 'Islandia',
    de: 'Island',
    nl: 'IJsland',
    zh: '冰岛',
  },
  {
    en: 'India',
    twoLetterCode: 'in',
    dial_code: '+91',
    fr: 'Inde',
    es: 'India',
    de: 'Indien',
    nl: 'India',
    zh: '印度',
  },
  {
    en: 'Indonesia',
    twoLetterCode: 'id',
    dial_code: '+62',
    fr: 'Indonésie',
    es: 'Indonesia',
    de: 'Indonesien',
    nl: 'Indonesië',
    zh: '印度尼西亚',
  },
  {
    en: 'Iran',
    valueOverride: 'Iran, Islamic Republic of',
    twoLetterCode: 'ir',
    dial_code: '+98',
    fr: 'Iran',
    es: 'Irán',
    de: 'Iran',
    nl: 'Iran',
    zh: '伊朗',
  },
  {
    en: 'Iraq',
    twoLetterCode: 'iq',
    dial_code: '+964',
    fr: 'Irak',
    es: 'Irak',
    de: 'Irak',
    nl: 'Irak',
    zh: '伊拉克',
  },
  {
    en: 'Ireland',
    twoLetterCode: 'ie',
    dial_code: '+353',
    fr: 'Irlande',
    es: 'Irlanda',
    de: 'Irland',
    nl: 'Ierland',
    zh: '爱尔兰',
  },
  {
    en: 'Isle of Man',
    twoLetterCode: 'im',
    dial_code: '+44',
    fr: 'Île de Man',
    es: 'Isla de Man',
    de: 'Isle of Man',
    nl: 'Isle of Man',
    zh: '马恩岛',
  },
  {
    en: 'Israel',
    twoLetterCode: 'il',
    dial_code: '+972',
    fr: 'Israël',
    es: 'Israel',
    de: 'Israel',
    nl: 'Israël',
    zh: '以色列',
  },
  {
    en: 'Italy',
    twoLetterCode: 'it',
    dial_code: '+39',
    fr: 'Italie',
    es: 'Italia',
    de: 'Italien',
    nl: 'Italië',
    zh: '意大利',
  },
  {
    en: 'Jamaica',
    twoLetterCode: 'jm',
    dial_code: '+1876',
    fr: 'Jamaïque',
    es: 'Jamaica',
    de: 'Jamaika',
    nl: 'Jamaica',
    zh: '牙买加',
  },
  {
    en: 'Japan',
    twoLetterCode: 'jp',
    dial_code: '+81',
    fr: 'Japon',
    es: 'Japón',
    de: 'Japan',
    nl: 'Japan',
    zh: '日本',
  },
  {
    en: 'Jersey',
    twoLetterCode: 'je',
    dial_code: '+44',
    fr: 'Jersey',
    es: 'Jersey',
    de: 'Jersey',
    nl: 'Jersey',
    zh: '泽西岛',
  },
  {
    en: 'Jordan',
    twoLetterCode: 'jo',
    dial_code: '+962',
    fr: 'Jordanie',
    es: 'Jordania',
    de: 'Jordanien',
    nl: 'Jordanië',
    zh: '约旦',
  },
  {
    en: 'Kazakhstan',
    twoLetterCode: 'kz',
    dial_code: '+7',
    fr: 'Kazakhstan',
    es: 'Kazajistán',
    de: 'Kasachstan',
    nl: 'Kazachstan',
    zh: '哈萨克斯坦',
  },
  {
    en: 'Kenya',
    twoLetterCode: 'ke',
    dial_code: '+254',
    fr: 'Kenya',
    es: 'Kenia',
    de: 'Kenia',
    nl: 'Kenia',
    zh: '肯尼亚',
  },
  {
    en: 'Kiribati',
    twoLetterCode: 'ki',
    dial_code: '+686',
    fr: 'Kiribati',
    es: 'Kiribati',
    de: 'Kiribati',
    nl: 'Kiribati',
    zh: '基里巴斯',
  },
  {
    en: 'Kuwait',
    twoLetterCode: 'kw',
    dial_code: '+965',
    fr: 'Koweït',
    es: 'Kuwait',
    de: 'Kuwait',
    nl: 'Koeweit',
    zh: '科威特',
  },
  {
    en: 'Kyrgyzstan',
    twoLetterCode: 'kg',
    dial_code: '+996',
    fr: 'Kirghizistan',
    es: 'Kirguistán',
    de: 'Kirgisistan',
    nl: 'Kirgizië',
    zh: '吉尔吉斯斯坦',
  },
  {
    en: "Lao People's Democratic Republic",
    twoLetterCode: 'la',
    dial_code: '+856',
    fr: 'Lao, République démocratique populaire',
    es: 'República Democrática Popular Lao',
    de: 'Laos, Demokratische Volksrepublik',
    nl: 'Lao Democratische Volksrepubliek',
    zh: '老挝人民民主共和国',
  },
  {
    en: 'Latvia',
    twoLetterCode: 'lv',
    dial_code: '+371',
    fr: 'Lettonie',
    es: 'Letonia',
    de: 'Lettland',
    nl: 'Letland',
    zh: '拉脱维亚',
  },
  {
    en: 'Lebanon',
    twoLetterCode: 'lb',
    dial_code: '+961',
    fr: 'Liban',
    es: 'Líbano',
    de: 'Libanon',
    nl: 'Libanon',
    zh: '黎巴嫩',
  },
  {
    en: 'Lesotho',
    twoLetterCode: 'ls',
    dial_code: '+266',
    fr: 'Lesotho',
    es: 'Lesoto',
    de: 'Lesotho',
    nl: 'Lesotho',
    zh: '莱索托',
  },
  {
    en: 'Liberia',
    twoLetterCode: 'lr',
    dial_code: '+231',
    fr: 'Liberia',
    es: 'Liberia',
    de: 'Liberia',
    nl: 'Liberia',
    zh: '利比里亚',
  },
  {
    en: 'Libya',
    twoLetterCode: 'ly',
    dial_code: '+218',
    fr: 'Libye',
    es: 'Libia',
    de: 'Libyen',
    nl: 'Libië',
    zh: '利比亚',
  },
  {
    en: 'Liechtenstein',
    twoLetterCode: 'li',
    dial_code: '+423',
    fr: 'Liechtenstein',
    es: 'Liechtenstein',
    de: 'Liechtenstein',
    nl: 'Liechtenstein',
    zh: '列支敦士登',
  },
  {
    en: 'Lithuania',
    twoLetterCode: 'lt',
    dial_code: '+370',
    fr: 'Lituanie',
    es: 'Lituania',
    de: 'Litauen',
    nl: 'Litouwen',
    zh: '立陶宛',
  },
  {
    en: 'Luxembourg',
    twoLetterCode: 'lu',
    dial_code: '+352',
    fr: 'Luxembourg',
    es: 'Luxemburgo',
    de: 'Luxemburg',
    nl: 'Luxemburg',
    zh: '卢森堡',
  },
  {
    en: 'Macau',
    valueOverride: 'Macao',
    twoLetterCode: 'mo',
    dial_code: '+853',
    fr: 'Macao',
    es: 'Macao',
    de: 'Macau',
    nl: 'Macau',
    zh: '中国澳门',
  },
  {
    en: 'Macedonia',
    valueOverride: 'Macedonia, the former Yugoslav Republic of',
    twoLetterCode: 'mk',
    dial_code: '+389',
    fr: 'Macédoine',
    es: 'Macedonia',
    de: 'Nordmazedonien',
    nl: 'Macedonië',
    zh: '马其顿',
  },
  {
    en: 'Madagascar',
    twoLetterCode: 'mg',
    dial_code: '+261',
    fr: 'Madagascar',
    es: 'Madagascar',
    de: 'Madagaskar',
    nl: 'Madagaskar',
    zh: '马达加斯加',
  },
  {
    en: 'Malawi',
    twoLetterCode: 'mw',
    dial_code: '+265',
    fr: 'Malawi',
    es: 'Malawi',
    de: 'Malawi',
    nl: 'Malawi',
    zh: '马拉维',
  },
  {
    en: 'Malaysia',
    twoLetterCode: 'my',
    dial_code: '+60',
    fr: 'Malaisie',
    es: 'Malasia',
    de: 'Malaysia',
    nl: 'Maleisië',
    zh: '马来西亚',
  },
  {
    en: 'Maldives',
    twoLetterCode: 'mv',
    dial_code: '+960',
    fr: 'Maldives',
    es: 'Maldivas',
    de: 'Malediven',
    nl: 'Maldiven',
    zh: '马尔代夫',
  },
  {
    en: 'Mali',
    twoLetterCode: 'ml',
    dial_code: '+223',
    fr: 'Mali',
    es: 'Malí',
    de: 'Mali',
    nl: 'Mali',
    zh: '马里',
  },
  {
    en: 'Malta',
    twoLetterCode: 'mt',
    dial_code: '+356',
    fr: 'Malte',
    es: 'Malta',
    de: 'Malta',
    nl: 'Malta',
    zh: '马耳他',
  },
  {
    en: 'Marshall Islands',
    twoLetterCode: 'mh',
    dial_code: '+692',
    fr: 'Îles Marshall',
    es: 'Islas Marshall',
    de: 'Marshallinseln',
    nl: 'Marshalleilanden',
    zh: '马绍尔群岛',
  },
  {
    en: 'Martinique',
    twoLetterCode: 'mq',
    dial_code: '+596',
    fr: 'Martinique',
    es: 'Martinica',
    de: 'Martinique',
    nl: 'Martinique',
    zh: '马提尼克',
  },
  {
    en: 'Mauritania',
    twoLetterCode: 'mr',
    dial_code: '+222',
    fr: 'Mauritanie',
    es: 'Mauritania',
    de: 'Mauritanien',
    nl: 'Mauritanië',
    zh: '毛里塔尼亚',
  },
  {
    en: 'Mauritius',
    twoLetterCode: 'mu',
    dial_code: '+230',
    fr: 'Maurice',
    es: 'Mauricio',
    de: 'Mauritius',
    nl: 'Mauritius',
    zh: '毛里求斯',
  },
  {
    en: 'Mayotte',
    twoLetterCode: 'yt',
    dial_code: '+262',
    fr: 'Mayotte',
    es: 'Mayotte',
    de: 'Mayotte',
    nl: 'Mayotte',
    zh: '马约特',
  },
  {
    en: 'Mexico',
    twoLetterCode: 'mx',
    dial_code: '+52',
    fr: 'Mexique',
    es: 'México',
    de: 'Mexiko',
    nl: 'Mexico',
    zh: '墨西哥',
  },
  {
    en: 'Micronesia',
    twoLetterCode: 'fm',
    dial_code: '+691',
    fr: 'Micronésie',
    es: 'Micronesia',
    de: 'Mikronesien',
    nl: 'Micronesië',
    zh: '密克罗尼西亚',
  },
  {
    en: 'Moldova',
    valueOverride: 'Moldova, Republic of',
    twoLetterCode: 'md',
    dial_code: '+373',
    fr: 'Moldavie',
    es: 'Moldova',
    de: 'Moldawien',
    nl: 'Moldavië',
    zh: '摩尔多瓦',
  },
  {
    en: 'Monaco',
    twoLetterCode: 'mc',
    dial_code: '+377',
    fr: 'Monaco',
    es: 'Mónaco',
    de: 'Monaco',
    nl: 'Monaco',
    zh: '摩纳哥',
  },
  {
    en: 'Mongolia',
    twoLetterCode: 'mn',
    dial_code: '+976',
    fr: 'Mongolie',
    es: 'Mongolia',
    de: 'Mongolei',
    nl: 'Mongolië',
    zh: '蒙古',
  },
  {
    en: 'Montenegro',
    twoLetterCode: 'me',
    dial_code: '+382',
    fr: 'Monténégro',
    es: 'Montenegro',
    de: 'Montenegro',
    nl: 'Montenegro',
    zh: '黑山共和国',
  },
  {
    en: 'Montserrat',
    twoLetterCode: 'ms',
    dial_code: '+1664',
    fr: 'Montserrat',
    es: 'Montserrat',
    de: 'Montserrat',
    nl: 'Montserrat',
    zh: '蒙特塞拉特岛',
  },
  {
    en: 'Morocco',
    twoLetterCode: 'ma',
    dial_code: '+212',
    fr: 'Maroc',
    es: 'Marruecos',
    de: 'Marokko',
    nl: 'Marokko',
    zh: '摩洛哥',
  },
  {
    en: 'Mozambique',
    twoLetterCode: 'mz',
    dial_code: '+258',
    fr: 'Mozambique',
    es: 'Mozambique',
    de: 'Mosambik',
    nl: 'Mozambique',
    zh: '莫桑比克',
  },
  {
    en: 'Myanmar',
    twoLetterCode: 'mm',
    dial_code: '+95',
    fr: 'Myanmar',
    es: 'Myanmar',
    de: 'Myanmar',
    nl: 'Myanmar',
    zh: '缅甸',
  },
  {
    en: 'Namibia',
    twoLetterCode: 'na',
    dial_code: '+264',
    fr: 'Namibie',
    es: 'Namibia',
    de: 'Namibia',
    nl: 'Namibië',
    zh: '纳米比亚',
  },
  {
    en: 'Nauru',
    twoLetterCode: 'nr',
    dial_code: '+674',
    fr: 'Nauru',
    es: 'Nauru',
    de: 'Nauru',
    nl: 'Nauru',
    zh: '瑙鲁',
  },
  {
    en: 'Nepal',
    twoLetterCode: 'np',
    dial_code: '+977',
    fr: 'Népal',
    es: 'Nepal',
    de: 'Nepal',
    nl: 'Nepal',
    zh: '尼泊尔',
  },
  {
    en: 'Netherlands',
    twoLetterCode: 'nl',
    dial_code: '+31',
    fr: 'Pays-Bas',
    es: 'Países Bajos',
    de: 'Niederlande',
    nl: 'Nederland',
    zh: '荷兰',
  },
  {
    en: 'New Caledonia',
    twoLetterCode: 'nc',
    dial_code: '+687',
    fr: 'Nouvelle-Calédonie',
    es: 'Nueva Caledonia',
    de: 'Neukaledonien',
    nl: 'Nieuw-Caledonië',
    zh: '新喀里多尼亚',
  },
  {
    en: 'New Zealand',
    twoLetterCode: 'nz',
    dial_code: '+64',
    fr: 'Nouvelle-Zélande',
    es: 'Nueva Zelanda',
    de: 'Neuseeland',
    nl: 'Nieuw-Zeeland',
    zh: '新西兰',
  },
  {
    en: 'Nicaragua',
    twoLetterCode: 'ni',
    dial_code: '+505',
    fr: 'Nicaragua',
    es: 'Nicaragua',
    de: 'Nicaragua',
    nl: 'Nicaragua',
    zh: '尼加拉瓜',
  },
  {
    en: 'Niger',
    twoLetterCode: 'ne',
    dial_code: '+227',
    fr: 'Niger',
    es: 'Níger',
    de: 'Niger',
    nl: 'Niger',
    zh: '尼日尔',
  },
  {
    en: 'Nigeria',
    twoLetterCode: 'ng',
    dial_code: '+234',
    fr: 'Nigeria',
    es: 'Nigeria',
    de: 'Nigeria',
    nl: 'Nigeria',
    zh: '尼日利亚',
  },
  {
    en: 'Niue',
    twoLetterCode: 'nu',
    dial_code: '+683',
    fr: 'Niué',
    es: 'Niue',
    de: 'Niue',
    nl: 'Niue',
    zh: '纽埃',
  },
  {
    en: 'Norfolk Island',
    twoLetterCode: 'nf',
    dial_code: '+672',
    fr: 'Île Norfolk',
    es: 'Isla Norfolk',
    de: 'Norfolkinsel',
    nl: 'Norfolkeiland',
    zh: '诺福克岛',
  },
  {
    en: 'North Korea',
    valueOverride: "Korea, Democratic People's Republic of",
    twoLetterCode: 'kp',
    dial_code: '+850',
    fr: 'Corée du Nord',
    es: 'Corea del Norte',
    de: 'Nordkorea',
    nl: 'Noord-Korea',
    zh: '朝鲜',
  },
  {
    en: 'Northern Mariana Islands',
    twoLetterCode: 'mp',
    dial_code: '+1670',
    fr: 'Îles Mariannes du Nord',
    es: 'Islas Marianas del Norte',
    de: 'Nördliche Marianen',
    nl: 'Noordelijke Marianen',
    zh: '北马里亚纳群岛',
  },
  {
    en: 'Norway',
    twoLetterCode: 'no',
    dial_code: '+47',
    fr: 'Norvège',
    es: 'Noruega',
    de: 'Norwegen',
    nl: 'Noorwegen',
    zh: '挪威',
  },
  {
    en: 'Oman',
    twoLetterCode: 'om',
    dial_code: '+968',
    fr: 'Oman',
    es: 'Omán',
    de: 'Oman',
    nl: 'Oman',
    zh: '阿曼',
  },
  {
    en: 'Pakistan',
    twoLetterCode: 'pk',
    dial_code: '+92',
    fr: 'Pakistan',
    es: 'Pakistán',
    de: 'Pakistan',
    nl: 'Pakistan',
    zh: '巴基斯坦',
  },
  {
    en: 'Palau',
    twoLetterCode: 'pw',
    dial_code: '+680',
    fr: 'Palau',
    es: 'Palaos',
    de: 'Palau',
    nl: 'Palau',
    zh: '帕劳',
  },
  {
    en: 'Palestine, State of',
    valueOverride: 'Palestine',
    twoLetterCode: 'ps',
    dial_code: '+970',
    fr: 'Palestine, État de',
    es: 'Palestina, Estado de',
    de: 'Palästina',
    nl: 'Palestina, (staat)',
    zh: '巴勒斯坦',
  },
  {
    en: 'Panama',
    twoLetterCode: 'pa',
    dial_code: '+507',
    fr: 'Panama',
    es: 'Panamá',
    de: 'Panama',
    nl: 'Panama',
    zh: '巴拿马',
  },
  {
    en: 'Papua New Guinea',
    twoLetterCode: 'pg',
    dial_code: '+675',
    fr: 'Papouasie-Nouvelle-Guinée',
    es: 'Papua Nueva Guinea',
    de: 'Papua-Neuguinea',
    nl: 'Papoea-Nieuw-Guinea',
    zh: '巴布亚新几内亚',
  },
  {
    en: 'Paraguay',
    twoLetterCode: 'py',
    dial_code: '+595',
    fr: 'Paraguay',
    es: 'Paraguay',
    de: 'Paraguay',
    nl: 'Paraguay',
    zh: '巴拉圭',
  },
  {
    en: 'Peru',
    twoLetterCode: 'pe',
    dial_code: '+51',
    fr: 'Pérou',
    es: 'Perú',
    de: 'Peru',
    nl: 'Peru',
    zh: '秘鲁',
  },
  {
    en: 'Philippines',
    twoLetterCode: 'ph',
    dial_code: '+63',
    fr: 'Philippines',
    es: 'Filipinas',
    de: 'Philippinen',
    nl: 'Filippijnen',
    zh: '菲律宾',
  },
  {
    en: 'Pitcairn',
    twoLetterCode: 'pn',
    dial_code: '+870',
    fr: 'Îles Pitcairn',
    es: 'Pitcairn',
    de: 'Pitcairn',
    nl: 'Pitcairn',
    zh: '皮特凯恩',
  },
  {
    en: 'Poland',
    twoLetterCode: 'pl',
    dial_code: '+48',
    fr: 'Pologne',
    es: 'Polonia',
    de: 'Polen',
    nl: 'Polen',
    zh: '波兰',
  },
  {
    en: 'Portugal',
    twoLetterCode: 'pt',
    dial_code: '+351',
    fr: 'Portugal',
    es: 'Portugal',
    de: 'Portugal',
    nl: 'Portugal',
    zh: '葡萄牙',
  },
  {
    en: 'Puerto Rico',
    twoLetterCode: 'pr',
    dial_code: '+1787',
    fr: 'Porto Rico',
    es: 'Puerto Rico',
    de: 'Puerto Rico',
    nl: 'Puerto Rico',
    zh: '波多黎各',
  },
  {
    en: 'Qatar',
    twoLetterCode: 'qa',
    dial_code: '+974',
    fr: 'Qatar',
    es: 'Qatar',
    de: 'Katar',
    nl: 'Qatar',
    zh: '卡塔尔',
  },
  {
    en: 'Romania',
    twoLetterCode: 'ro',
    dial_code: '+40',
    fr: 'Roumanie',
    es: 'Rumanía',
    de: 'Rumänien',
    nl: 'Roemenië',
    zh: '罗马尼亚',
  },
  {
    en: 'Russia',
    valueOverride: 'Russian Federation',
    twoLetterCode: 'ru',
    dial_code: '+7',
    fr: 'Russie',
    es: 'Rusia',
    de: 'Russland',
    nl: 'Rusland',
    zh: '俄罗斯',
  },
  {
    en: 'Rwanda',
    twoLetterCode: 'rw',
    dial_code: '+250',
    fr: 'Rwanda',
    es: 'Ruanda',
    de: 'Ruanda',
    nl: 'Rwanda',
    zh: '卢旺达',
  },
  {
    en: 'Réunion',
    valueOverride: 'Reunion',
    twoLetterCode: 're',
    dial_code: '+262',
    fr: 'La Réunion',
    es: 'Reunión',
    de: 'Réunion',
    nl: 'Réunion',
    zh: '留尼汪',
  },
  {
    en: 'Saint Barthélemy',
    twoLetterCode: 'bl',
    dial_code: '+590',
    fr: 'Saint-Barthélemy',
    es: 'San Bartolomé',
    de: 'Saint Barthélemy',
    nl: 'Saint-Barthélemy',
    zh: '圣巴泰勒米',
  },
  {
    en: 'Saint Helena',
    valueOverride: 'Saint Helena, Ascension and Tristan da Cunha',
    twoLetterCode: 'sh',
    dial_code: '+290',
    fr: 'Sainte-Hélène',
    es: 'Santa Elena',
    de: 'St. Helena',
    nl: 'Sint-Helena',
    zh: '圣赫勒拿',
  },
  {
    en: 'Saint Kitts and Nevis',
    twoLetterCode: 'kn',
    dial_code: '+1869',
    fr: 'Saint-Kitts-et-Nevis',
    es: 'San Cristóbal y Nieves',
    de: 'St. Kitts und Nevis',
    nl: 'Saint Kitts en Nevis',
    zh: '圣基茨和尼维斯',
  },
  {
    en: 'Saint Lucia',
    twoLetterCode: 'lc',
    dial_code: '+1758',
    fr: 'Sainte-Lucie',
    es: 'Santa Lucía',
    de: 'St. Lucia',
    nl: 'Saint Lucia',
    zh: '圣卢西亚',
  },
  {
    en: 'Saint Pierre and Miquelon',
    twoLetterCode: 'pm',
    dial_code: '+508',
    fr: 'Saint-Pierre-et-Miquelon',
    es: 'San Pedro y Miquelón',
    de: 'St. Pierre und Miquelon',
    nl: 'Saint-Pierre en Miquelon',
    zh: '圣皮埃尔和密克隆',
  },
  {
    en: 'Saint Vincent and the Grenadines',
    twoLetterCode: 'vc',
    dial_code: '+1784',
    fr: 'Saint-Vincent-et-les-Grenadines',
    es: 'San Vicente y las Granadinas',
    de: 'St. Vincent und die Grenadinen',
    nl: 'Saint Vincent en de Grenadines',
    zh: '圣文森特和格林纳丁斯',
  },
  {
    en: 'Samoa',
    twoLetterCode: 'ws',
    dial_code: '+685',
    fr: 'Samoa',
    es: 'Samoa',
    de: 'Samoa',
    nl: 'Samoa',
    zh: '萨摩亚',
  },
  {
    en: 'San Marino',
    twoLetterCode: 'sm',
    dial_code: '+378',
    fr: 'Saint-Marin',
    es: 'San Marino',
    de: 'San Marino',
    nl: 'San Marino',
    zh: '圣马力诺',
  },
  {
    en: 'Sao Tome and Principe',
    twoLetterCode: 'st',
    dial_code: '+239',
    fr: 'Sao Tomé-et-Principe',
    es: 'Santo Tomé y Príncipe',
    de: 'Sao Tome und Principe',
    nl: 'Sao Tome en Principe',
    zh: '圣多美和普林西比',
  },
  {
    en: 'Saudi Arabia',
    twoLetterCode: 'sa',
    dial_code: '+966',
    fr: 'Arabie saoudite',
    es: 'Arabia Saudí',
    de: 'Saudi-Arabien',
    nl: 'Saoedi-Arabië',
    zh: '沙特阿拉伯',
  },
  {
    en: 'Senegal',
    twoLetterCode: 'sn',
    dial_code: '+221',
    fr: 'Sénégal',
    es: 'Senegal',
    de: 'Senegal',
    nl: 'Senegal',
    zh: '塞内加尔',
  },
  {
    en: 'Serbia',
    twoLetterCode: 'rs',
    dial_code: '+381',
    fr: 'Serbie',
    es: 'Serbia',
    de: 'Serbien',
    nl: 'Servië',
    zh: '塞尔维亚',
  },
  {
    en: 'Seychelles',
    twoLetterCode: 'sc',
    dial_code: '+248',
    fr: 'Seychelles',
    es: 'Seychelles',
    de: 'Seychellen',
    nl: 'Seychellen',
    zh: '塞舌尔',
  },
  {
    en: 'Sierra Leone',
    twoLetterCode: 'sl',
    dial_code: '+232',
    fr: 'Sierra Leone',
    es: 'Sierra Leona',
    de: 'Sierra Leone',
    nl: 'Sierra Leone',
    zh: '塞拉利昂',
  },
  {
    en: 'Singapore',
    twoLetterCode: 'sg',
    dial_code: '+65',
    fr: 'Singapour',
    es: 'Singapur',
    de: 'Singapur',
    nl: 'Singapore',
    zh: '新加坡',
  },
  {
    en: 'Slovakia',
    twoLetterCode: 'sk',
    dial_code: '+421',
    fr: 'Slovaquie',
    es: 'Eslovaquia',
    de: 'Slowakei',
    nl: 'Slowakije',
    zh: '斯洛伐克',
  },
  {
    en: 'Slovenia',
    twoLetterCode: 'si',
    dial_code: '+386',
    fr: 'Slovénie',
    es: 'Eslovenia',
    de: 'Slowenien',
    nl: 'Slovenië',
    zh: '斯洛文尼亚',
  },
  {
    en: 'Solomon Islands',
    twoLetterCode: 'sb',
    dial_code: '+677',
    fr: 'Îles Salomon',
    es: 'Islas Salomón',
    de: 'Salomonen',
    nl: 'Solomoneilanden',
    zh: '所罗门群岛',
  },
  {
    en: 'Somalia',
    twoLetterCode: 'so',
    dial_code: '+252',
    fr: 'Somalie',
    es: 'Somalia',
    de: 'Somalia',
    nl: 'Somalië',
    zh: '索马里',
  },
  {
    en: 'South Africa',
    twoLetterCode: 'za',
    dial_code: '+27',
    fr: 'Afrique du Sud',
    es: 'Sudáfrica',
    de: 'Südafrika',
    nl: 'Zuid-Afrika',
    zh: '南非',
  },
  {
    en: 'South Korea',
    twoLetterCode: 'kr',
    dial_code: '+82',
    fr: 'Corée du Sud',
    es: 'Corea del Sur',
    de: 'Südkorea',
    nl: 'Zuid-Korea',
    zh: '韩国',
  },
  {
    en: 'South Sudan',
    twoLetterCode: 'ss',
    dial_code: '+211',
    fr: 'South Sudan',
    es: 'South Sudan',
    de: 'South Sudan',
    nl: 'South Sudan',
    zh: '南苏丹',
  },
  {
    en: 'Spain',
    twoLetterCode: 'es',
    dial_code: '+34',
    fr: 'Espagne',
    es: 'España',
    de: 'Spanien',
    nl: 'Spain',
    zh: '西班牙',
  },
  {
    en: 'Sri Lanka',
    twoLetterCode: 'lk',
    dial_code: '+94',
    fr: 'Sri Lanka',
    es: 'Sri Lanka',
    de: 'Sri Lanka',
    nl: 'Sri Lanka',
    zh: '斯里兰卡',
  },
  {
    en: 'Sudan',
    twoLetterCode: 'sd',
    dial_code: '+249',
    fr: 'Soudan',
    es: 'Sudán',
    de: 'Sudan',
    nl: 'Soedan',
    zh: '苏丹',
  },
  {
    en: 'Suriname',
    twoLetterCode: 'sr',
    dial_code: '+597',
    fr: 'Suriname',
    es: 'Surinam',
    de: 'Surinam',
    nl: 'Suriname',
    zh: '苏里南',
  },
  {
    en: 'Svalbard and Jan Mayen Islands',
    valueOverride: 'Svalbard and Jan Mayen',
    twoLetterCode: 'sj',
    dial_code: '+47',
    fr: 'Svalbard et Jan Mayen',
    es: 'Islas Svalbard y Jan Mayen',
    de: 'Svalbard und Jan Mayen Islands',
    nl: 'Svalbard en Jan Mayen',
    zh: '斯瓦尔巴和扬马延群岛',
  },
  {
    en: 'Sweden',
    twoLetterCode: 'se',
    dial_code: '+46',
    fr: 'Suède',
    es: 'Suecia',
    de: 'Schweden',
    nl: 'Zweden',
    zh: '瑞典',
  },
  {
    en: 'Switzerland',
    twoLetterCode: 'ch',
    dial_code: '+41',
    fr: 'Suisse',
    es: 'Suiza',
    de: 'Schweiz',
    nl: 'Zwitserland',
    zh: '瑞士',
  },
  {
    en: 'Syria',
    valueOverride: 'Syrian Arab Republic',
    twoLetterCode: 'sy',
    dial_code: '+963',
    fr: 'Syrie',
    es: 'Siria',
    de: 'Syrien',
    nl: 'Syrië',
    zh: '叙利亚',
  },
  {
    en: 'Taiwan',
    twoLetterCode: 'tw',
    dial_code: '+886',
    fr: 'Taïwan',
    es: 'Taiwán',
    de: 'Taiwan',
    nl: 'Taiwan',
    zh: '中国台湾',
  },
  {
    en: 'Tajikistan',
    twoLetterCode: 'tj',
    dial_code: '+992',
    fr: 'Tadjikistan',
    es: 'Tayikistán',
    de: 'Tadschikistan',
    nl: 'Tadzjikistan',
    zh: '塔吉克斯坦',
  },
  {
    en: 'Tanzania',
    valueOverride: 'Tanzania, United Republic of',
    twoLetterCode: 'tz',
    dial_code: '+255',
    fr: 'Tanzanie',
    es: 'Tanzania',
    de: 'Tansania',
    nl: 'Tanzania',
    zh: '坦桑尼亚',
  },
  {
    en: 'Thailand',
    twoLetterCode: 'th',
    dial_code: '+66',
    fr: 'Thaïlande',
    es: 'Tailandia',
    de: 'Thailand',
    nl: 'Thailand',
    zh: '泰国',
  },
  {
    en: 'Timor-Leste',
    twoLetterCode: 'tl',
    dial_code: '+670',
    fr: 'Timor oriental',
    es: 'Timor-Leste',
    de: 'Osttimor',
    nl: 'Oost-Timor',
    zh: '东帝汶',
  },
  {
    en: 'Togo',
    twoLetterCode: 'tg',
    dial_code: '+228',
    fr: 'Togo',
    es: 'Togo',
    de: 'Togo',
    nl: 'Togo',
    zh: '多哥',
  },
  {
    en: 'Tokelau',
    twoLetterCode: 'tk',
    dial_code: '+690',
    fr: 'Tokélaou',
    es: 'Tokelau',
    de: 'Tokelau',
    nl: 'Tokelau',
    zh: '托克劳',
  },
  {
    en: 'Tonga',
    twoLetterCode: 'to',
    dial_code: '+676',
    fr: 'Tonga',
    es: 'Tonga',
    de: 'Tonga',
    nl: 'Tonga',
    zh: '汤加',
  },
  {
    en: 'Trinidad and Tobago',
    twoLetterCode: 'tt',
    dial_code: '+1868',
    fr: 'Trinité-et-Tobago',
    es: 'Trinidad y Tobago',
    de: 'Trinidad und Tobago',
    nl: 'Trinidad en Tobago',
    zh: '特立尼达和多巴哥',
  },
  {
    en: 'Tunisia',
    twoLetterCode: 'tn',
    dial_code: '+216',
    fr: 'Tunisie',
    es: 'Túnez',
    de: 'Tunesien',
    nl: 'Tunesië',
    zh: '突尼斯',
  },
  {
    en: 'Turkey',
    twoLetterCode: 'tr',
    dial_code: '+90',
    fr: 'Turquie',
    es: 'Turquía',
    de: 'Türkei',
    nl: 'Turkije',
    zh: '土耳其',
  },
  {
    en: 'Turkmenistan',
    twoLetterCode: 'tm',
    dial_code: '+993',
    fr: 'Turkménistan',
    es: 'Turkmenistán',
    de: 'Turkmenistan',
    nl: 'Turkmenistan',
    zh: '土库曼斯坦',
  },
  {
    en: 'Turks and Caicos Islands',
    twoLetterCode: 'tc',
    dial_code: '+1649',
    fr: 'Îles Turques et Caïques',
    es: 'Islas Turcas y Caicos',
    de: 'Turks und Caicosinseln',
    nl: 'Turks- en Caicoseilanden',
    zh: '特克斯和凯科斯群岛',
  },
  {
    en: 'Tuvalu',
    twoLetterCode: 'tv',
    dial_code: '+688',
    fr: 'Tuvalu',
    es: 'Tuvalu',
    de: 'Tuvalu',
    nl: 'Tuvalu',
    zh: '图瓦卢',
  },
  {
    en: 'Uganda',
    twoLetterCode: 'ug',
    dial_code: '+256',
    fr: 'Ouganda',
    es: 'Uganda',
    de: 'Uganda',
    nl: 'Oeganda',
    zh: '乌干达',
  },
  {
    en: 'Ukraine',
    twoLetterCode: 'ua',
    dial_code: '+380',
    fr: 'Ukraine',
    es: 'Ucrania',
    de: 'Ukraine',
    nl: 'Oekraïne',
    zh: '乌克兰',
  },
  {
    en: 'United Arab Emirates',
    twoLetterCode: 'ae',
    dial_code: '+971',
    fr: 'Émirats arabes unis',
    es: 'Emiratos Árabes Unidos',
    de: 'Vereinigte Arabische Emirate',
    nl: 'Verenigde Arabische Emiraten',
    zh: '阿拉伯联合酋长国',
  },
  {
    en: 'Uruguay',
    twoLetterCode: 'uy',
    dial_code: '+598',
    fr: 'Uruguay',
    es: 'Uruguay',
    de: 'Uruguay',
    nl: 'Uruguay',
    zh: '乌拉圭',
  },
  {
    en: 'Uzbekistan',
    twoLetterCode: 'uz',
    dial_code: '+998',
    fr: 'Ouzbékistan',
    es: 'Uzbekistán',
    de: 'Usbekistan',
    nl: 'Oezbekistan',
    zh: '乌兹别克斯坦',
  },
  {
    en: 'Vanuatu',
    twoLetterCode: 'vu',
    dial_code: '+678',
    fr: 'Vanuatu',
    es: 'Vanuatu',
    de: 'Vanuatu',
    nl: 'Vanuatu',
    zh: '瓦努阿图',
  },
  {
    en: 'Venezuela',
    valueOverride: 'Venezuela, Bolivarian Republic of',
    twoLetterCode: 've',
    dial_code: '+58',
    fr: 'Venezuela',
    es: 'Venezuela',
    de: 'Venezuela',
    nl: 'Venezuela',
    zh: '委内瑞拉',
  },
  {
    en: 'Vietnam',
    valueOverride: 'Viet Nam',
    twoLetterCode: 'vn',
    dial_code: '+84',
    fr: 'Vietnam',
    es: 'Vietnam',
    de: 'Vietnam',
    nl: 'Vietnam',
    zh: '越南',
  },
  {
    en: 'Virgin Islands, British',
    twoLetterCode: 'vg',
    dial_code: '+1284',
    fr: 'Îles Vierges britanniques',
    es: 'Islas Vírgenes Británicas',
    de: 'Britische Jungferninseln',
    nl: 'Maagdeneilanden, Britse',
    zh: '英属维京群岛',
  },
  {
    en: 'Wallis and Futuna',
    twoLetterCode: 'wf',
    dial_code: '+681',
    fr: 'Wallis-et-Futuna',
    es: 'Wallis y Futuna',
    de: 'Wallis und Futuna',
    nl: 'Wallis en Futuna',
    zh: '瓦利斯和富图纳群岛',
  },
  {
    en: 'Western Sahara',
    twoLetterCode: 'eh',
    dial_code: '+212',
    fr: 'Sahara occidental',
    es: 'Sáhara Occidental',
    de: 'Westsahara',
    nl: 'Westelijke Sahara',
    zh: '西撒哈拉',
  },
  {
    en: 'Yemen',
    twoLetterCode: 'ye',
    dial_code: '+967',
    fr: 'Yémen',
    es: 'Yemen',
    de: 'Jemen',
    nl: 'Jemen',
    zh: '也门',
  },
  {
    en: 'Zambia',
    twoLetterCode: 'zm',
    dial_code: '+260',
    fr: 'Zambie',
    es: 'Zambia',
    de: 'Sambia',
    nl: 'Zambia',
    zh: '赞比亚',
  },
  {
    en: 'Zimbabwe',
    twoLetterCode: 'zw',
    dial_code: '+263',
    fr: 'Zimbabwe',
    es: 'Zimbabue',
    de: 'Simbabwe',
    nl: 'Zimbabwe',
    zh: '津巴布韦',
  },
];
